// extracted by mini-css-extract-plugin
module.exports = {"forecastList":"WeatherFaq_forecastList__n_9J8"};